export type AuthToken = {
  refreshToken: string;
  accessToken: string;
};

export const normalizeAuthToken = (data: any): AuthToken => ({
  refreshToken: data.refreshToken,
  accessToken: data.accessToken,
});
